import React, { createContext, useEffect, useState, ReactNode } from "react";
import { auth } from "../firebase"; // Import Firebase auth
import { User } from "firebase/auth";

interface AuthContextType {
	user: User | null;
}

interface AuthProviderProps {
	children: ReactNode;
}

export const AuthContext = createContext<AuthContextType>({ user: null });

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
	const [user, setUser] = useState<User | null>(null);

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(firebaseUser => {
			setUser(firebaseUser);
		});

		return unsubscribe;
	}, []);

	const value = {
		user,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
